// Mesure d'audience, chargee uniquement apres consentement explicite.
//
// Tant que ANALYTIQUE.fournisseur vaut null dans src/data/site.js,
// aucun script n'est charge, quel que soit le choix du visiteur.
//
// Pour activer Google Analytics 4 :
//   ANALYTIQUE = { fournisseur: 'ga4', id: 'G-XXXXXXXXXX' }
// Pour activer Matomo :
//   ANALYTIQUE = { fournisseur: 'matomo', id: '1', hote: 'https://analytics.exemple.fr/' }
//
// Dans les deux cas, penser a declarer l'outil dans la page /cookies.

import { ANALYTIQUE } from './data/site';
import { estAccepte, EVENEMENT } from './components/consentement';

let charge = false;

function chargerGa4(id) {
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag('js', new Date());
  // Anonymisation de l'adresse IP et desactivation des signaux publicitaires.
  gtag('config', id, {
    anonymize_ip: true,
    allow_google_signals: false,
    allow_ad_personalization_signals: false,
  });
}

function chargerMatomo(id, hote) {
  const base = hote.endsWith('/') ? hote : hote + '/';
  window._paq = window._paq || [];
  window._paq.push(['trackPageView']);
  window._paq.push(['enableLinkTracking']);
  window._paq.push(['setTrackerUrl', base + 'matomo.php']);
  window._paq.push(['setSiteId', id]);
  const s = document.createElement('script');
  s.async = true;
  s.src = base + 'matomo.js';
  document.head.appendChild(s);
}

function activer() {
  if (charge) return;
  const { fournisseur, id, hote } = ANALYTIQUE || {};
  if (!fournisseur || !id) return;
  if (!estAccepte('audience')) return;

  if (fournisseur === 'ga4') chargerGa4(id);
  else if (fournisseur === 'matomo' && hote) chargerMatomo(id, hote);
  else return;

  charge = true;
}

// Retire les cookies deposes par l'outil quand le visiteur retire son accord.
function nettoyer() {
  const prefixes = ['_ga', '_gid', '_gat', '_pk_'];
  document.cookie.split(';').forEach((c) => {
    const nom = c.split('=')[0].trim();
    if (prefixes.some((p) => nom.startsWith(p))) {
      const hote = window.location.hostname;
      const domaines = [hote, '.' + hote, '.' + hote.split('.').slice(-2).join('.')];
      domaines.forEach((d) => {
        document.cookie = `${nom}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${d}`;
      });
      document.cookie = `${nom}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
    }
  });
}

export function initAnalytique() {
  activer();
  window.addEventListener(EVENEMENT, (e) => {
    if (e.detail && e.detail.audience) activer();
    else nettoyer();
  });
}
